import styled from "styled-components";

export const NavbarWrapper = styled.div`
  width: 100%;
  position: static;
  top: 0%;
  background-color: #1a1a1d;
  ul {
    display: flex;
    width: 100%;
    border-bottom: 2px solid purple;
    justify-content: space-between;
    list-style-type: none;
    padding: 5px;
    align-items: center;
    margin-bottom: 0;
    li {
      text-decoration: none;
      .signOutBtn {
        padding: 5px 20px;
        border-radius: 20px;
        color: black;
        background-color: #c96567;

        font-weight: 700;
        font-size: 1.3rem;
        &:hover {
          background-color: #e7624f;
          color: white;
        }
      }
    }
    .navLinks {
      a {
        color: whitesmoke;
        text-decoration: none;
        font-size: 1.5rem;
        font-weight: 800;
        margin: 0 10px;
        position: relative;
        &.active {
          color: lightcoral;
          &:after {
            content: "";
            position: absolute;
            display: block;
            height: 2px;
            left: 0%;
            bottom: 0;
            background-color: #ffe400;
            animation: slide-in 0.3s ease-in forwards;
            @keyframes slide-in {
              from {
                left: 50%;
                width: 0;
              }
              to {
                left: 0%;
                width: 100%;
              }
            }
          }
        }
      }
    }
    .navHead {
      font-size: 1.7rem;
      font-weight: 700;
      background-clip: text;
      -webkit-background-clip: text;
      -moz-background-clip: text;
      -moz-text-fill-color: transparent;
      -webkit-text-fill-color: transparent;
      background-image: linear-gradient(90deg, #a100ffff 0%, #71c4ffff 100%);
      display: inline;
    }
    .profilePic {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 10px;
    }
  }

  @media only screen and (max-width: 500px) {
    .navLinks {
      display: none;
    }
  }
`;
